module.exports = __webpack_public_path__ + "static/media/chevron-compact-right.ef76052f.svg";